import { shouldTrackEvents } from "./shouldTrackEvents";

export const fbqTrack = (eventName, data = {}) => {
  if (typeof window.fbq === 'function' && shouldTrackEvents()) {
    window.fbq('track', eventName, data);
  } else {
    console.warn('Facebook Pixel not initialized');
  }
};
